import { useTheme } from '@mui/material'
import { Background } from 'reactflow'

function WorkflowCanvasBackground() {
  const theme = useTheme()

  return <Background color={theme.palette.grey[200]} size={theme.spacingValue * 0.25} gap={theme.spacingValue * 2} />
}

export default WorkflowCanvasBackground
